import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { OktaAuthGuard } from '../app.guard';
import { LayoutComponent } from '../layout/layout/layout.component';
import { CybersocxdrDashboardComponent } from './cybersocxdrdashboard/cybersocxdrdashboard.component';
import { CybersocxdrSLAComponent } from './cybersocxdrsla/cybersocxdrsla.component';
import { CybersocxdrContactComponent } from './cybersocxdrcontact/cybersocxdrcontact.component';
import { CybersocxdrIncidentsComponent } from './cybersocxdrincidents/cybersocxdrincidents.component';
import { CybersocxdrcomopgenComponent } from './cybersocxdrcomopgen/cybersocxdrcomopgen.component';
import { CybersocxdrGuard } from './cybersocxdr.guard';
import { CybersocXdrIncidentDetailsComponent } from './cybersocxdrincidentdetails/cybersocxdrincidentdetails.component';
import { XtendedSOC4A3WComponent } from './cybersocxdr4A3W/xtendedsoc4A3W.component';

const routes: Routes = [
  {
    path: 'xtended-soc',
    component: LayoutComponent,
    canActivate: [OktaAuthGuard, CybersocxdrGuard],
    children: [
      { path: '', redirectTo: 'xtended-soc', pathMatch: 'full' },
      {
        path: 'dashboard',
        component: CybersocxdrDashboardComponent,
        pathMatch: 'full',
        data: {
          title: 'menu.dashboard',
          urls: [{ title: 'menu.dashboard' }, { title: 'menu.dashboard' }],
        },
      },
      {
        path: 'sla',
        component: CybersocxdrSLAComponent,
        pathMatch: 'full',
        data: {
          title: 'menu.dashboard',
          urls: [{ title: 'menu.dashboard' }, { title: 'menu.dashboard' }],
        },
      },
      {
        path: 'comop',
        component: CybersocxdrcomopgenComponent,
        pathMatch: 'full',
        data: {
          title: 'menu.dashboard',
          urls: [{ title: 'menu.dashboard' }, { title: 'menu.dashboard' }],
        },
      },
      {
        path: 'incidents',
        component: CybersocxdrIncidentsComponent,
        pathMatch: 'full',
        data: {
          title: 'menu.dashboard',
          urls: [{ title: 'menu.dashboard' }, { title: 'menu.dashboard' }],
        },
      },
      {
        path: '4A3W',
        component: XtendedSOC4A3WComponent,
        pathMatch: 'full',
        data: {
          title: 'menu.dashboard',
          urls: [{ title: 'menu.dashboard' }, { title: 'menu.dashboard' }],
        },
      },
      {
        path: 'incident/:incidentId',
        component: CybersocXdrIncidentDetailsComponent,
        pathMatch: 'full',
        data: {
          title: 'menu.dashboard',
          urls: [{ title: 'menu.dashboard' }, { title: 'menu.dashboard' }],
        },
      },
      {
        path: 'xtended-soc',
        component: CybersocxdrContactComponent,
        pathMatch: 'full',
        data: {
          title: 'menu.dashboard',
          urls: [{ title: 'menu.dashboard' }, { title: 'menu.dashboard' }],
        },
      },
    ],
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class CybersocxdrRoutingModule {}
